export const messageListLabel = "VNb";
export const skipToMessageList = "WNb";
export default {messageListLabel,skipToMessageList};